module.exports = __webpack_public_path__ + "img/lema-mark.1840b99a.svg";